import style from "./TaskCompany.module.css"
const TaskCompany=({children})=>{
    return(
            <div className={style.TaskCompany}>
                    <h5>{children}</h5>
            </div>        
    )
}
export default TaskCompany